'use client';

import Link from 'next/link';

export default function TermosDeUtilizacaoPage() {
  const currentYear = new Date()?.getFullYear();

  return (
    <div style={{ backgroundColor: '#F8F9FA', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <header style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link href="/landing-page" aria-label="GestPub — Gestão Pública e Consultoria Autárquica — Página inicial" className="inline-block focus-visible:outline-none">
            <img
              src="/assets/images/6-1773621431219.png"
              alt="GestPub — Gestão Pública e Consultoria Autárquica"
              style={{ height: 38, width: 'auto', display: 'block', flexShrink: 0, mixBlendMode: 'multiply' }}
            />
          </Link>
          <Link
            href="/landing-page"
            style={{ fontSize: '0.82rem', color: '#6B7280', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#272727')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}
          >
            Voltar à página inicial
          </Link>
        </div>
      </header>
      {/* Teal accent line */}
      <div className="h-1" style={{ backgroundColor: '#009688' }} />
      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-14">
        {/* Page title */}
        <div className="mb-10">
          <p style={{ fontSize: '0.75rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#009688', fontWeight: 600, marginBottom: '0.75rem' }}>
            GestPub, Serviço GP Otimiza
          </p>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#272727', lineHeight: 1.25, marginBottom: '1rem' }}>
            Termos de Utilização
          </h1>
          <p style={{ fontSize: '0.85rem', color: '#6B7280' }}>
            Última atualização: março de {currentYear}
          </p>
        </div>

        <div style={{ backgroundColor: '#FFFFFF', borderRadius: 10, border: '1px solid rgba(0,0,0,0.08)', padding: '2.5rem' }}>
          <div className="space-y-8" style={{ color: '#374151', lineHeight: 1.75, fontSize: '0.92rem' }}>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>1. Identificação e Âmbito</h2>
              <p>
                A presente plataforma de diagnóstico organizacional é desenvolvida e disponibilizada pela <strong>GestPub – Gestão Pública e Consultoria Autárquica, Lda.</strong>, no âmbito do serviço GP Otimiza, dedicado ao apoio à modernização e à melhoria da capacidade organizacional de municípios portugueses.
              </p>
              <p className="mt-3">
                O acesso e a utilização desta plataforma implicam a aceitação integral dos presentes Termos de Utilização. Caso não concorde com os termos aqui estabelecidos, deverá abster-se de utilizar a plataforma.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>2. Objeto da Plataforma</h2>
              <p>
                O GP Otimiza é um serviço da GestPub que disponibiliza um instrumento de diagnóstico de capacidade organizacional municipal, desenvolvido com base em metodologia própria e experiência acumulada no setor da administração pública local. O diagnóstico tem carácter indicativo e destina-se a apoiar a reflexão interna e a identificação de oportunidades de melhoria organizacional.
              </p>
              <p className="mt-3">
                O resultado do diagnóstico não constitui um relatório de auditoria, uma avaliação de conformidade legal nem um parecer técnico vinculativo. Trata-se de um instrumento de orientação estratégica, cujos resultados devem ser interpretados no contexto específico de cada município.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>3. Utilizadores Autorizados</h2>
              <p>
                A plataforma destina-se exclusivamente a representantes de municípios portugueses, nomeadamente presidentes de câmara, vereadores, dirigentes municipais, técnicos superiores e demais colaboradores com responsabilidades de gestão ou de modernização organizacional.
              </p>
              <p className="mt-3">
                A utilização da plataforma por parte de entidades ou indivíduos não enquadrados no perfil acima descrito não é autorizada e poderá ser objeto de restrição por parte da GestPub.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>4. Condições de Utilização</h2>
              <p>O utilizador compromete-se a:</p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Fornecer informações verdadeiras, atuais e completas no momento do preenchimento do formulário de identificação;</li>
                <li>Utilizar a plataforma exclusivamente para os fins a que se destina, abstendo-se de qualquer utilização abusiva, fraudulenta ou contrária à lei;</li>
                <li>Não reproduzir, distribuir ou comercializar o conteúdo da plataforma sem autorização prévia e escrita da GestPub;</li>
                <li>Não tentar aceder a áreas restritas da plataforma ou interferir com o seu funcionamento técnico.</li>
              </ul>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>5. Propriedade Intelectual</h2>
              <p>
                Todos os conteúdos disponibilizados na plataforma GP Otimiza, incluindo textos, metodologias, instrumentos de diagnóstico, gráficos, logótipos e demais elementos visuais, são propriedade exclusiva da GestPub ou são utilizados com a devida autorização dos respetivos titulares.
              </p>
              <p className="mt-3">
                É expressamente proibida a reprodução, adaptação, distribuição ou qualquer outra forma de utilização dos conteúdos da plataforma sem autorização prévia e escrita da GestPub, sob pena de responsabilidade civil e criminal nos termos da legislação aplicável.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>6. Limitação de Responsabilidade</h2>
              <p>
                A GestPub não garante que a plataforma esteja permanentemente disponível, isenta de erros ou que os resultados do diagnóstico sejam adequados a todas as situações específicas de cada município. A GestPub não se responsabiliza por decisões tomadas com base exclusiva nos resultados do diagnóstico, nem por quaisquer danos diretos ou indiretos resultantes da utilização da plataforma.
              </p>
              <p className="mt-3">
                Os resultados do diagnóstico têm carácter meramente indicativo e devem ser complementados com uma análise aprofundada realizada por profissionais qualificados, como os especialistas da GestPub no âmbito do serviço GP Otimiza.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>7. Disponibilidade da Plataforma</h2>
              <p>
                A GestPub reserva-se o direito de suspender, alterar ou descontinuar a plataforma, no todo ou em parte, a qualquer momento e sem aviso prévio, nomeadamente para efeitos de manutenção, atualização ou melhoria do serviço. A GestPub não se responsabiliza por eventuais perdas ou inconvenientes resultantes de interrupções temporárias do serviço.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>8. Lei Aplicável e Foro Competente</h2>
              <p>
                Os presentes Termos de Utilização são regidos pela lei portuguesa. Para a resolução de quaisquer litígios emergentes da utilização da plataforma, é competente o foro da comarca de Lisboa, com expressa renúncia a qualquer outro.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>9. Alterações aos Termos de Utilização</h2>
              <p>
                A GestPub reserva-se o direito de alterar os presentes Termos de Utilização a qualquer momento. As alterações produzem efeitos a partir da data da sua publicação nesta página. Recomenda-se a consulta regular deste documento.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>10. Contacto</h2>
              <p>
                Para qualquer questão relacionada com os presentes Termos de Utilização, pode contactar a GestPub através dos seguintes meios:
              </p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Correio eletrónico: <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a></li>
                <li>Telefone: (+351) 214 846 546</li>
                <li>Morada: Avenida da República, Ed. República, 1.º Piso, Escritório E, Alcoitão, 2645-143 Estoril</li>
              </ul>
            </section>

          </div>
        </div>
      </main>
      {/* Footer */}
      <footer style={{ backgroundColor: '#272727' }}>
        <div className="h-1" style={{ backgroundColor: '#009688' }} />
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
            &copy; {currentYear} GestPub – Gestão Pública e Consultoria Autárquica. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            {[
              { label: 'Política de Privacidade', href: '/politica-de-privacidade' },
              { label: 'Termos de Utilização', href: '/termos-de-utilizacao' },
              { label: 'RGPD', href: '/rgpd' },
            ]?.map((link) => (
              <Link
                key={link?.label}
                href={link?.href}
                className="transition-colors duration-200"
                style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: link?.href === '/termos-de-utilizacao' ? '#FFFFFF' : 'rgba(255,255,255,0.35)', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                onMouseLeave={(e) => (e.currentTarget.style.color = link?.href === '/termos-de-utilizacao' ? '#FFFFFF' : 'rgba(255,255,255,0.35)')}
              >
                {link?.label}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
